exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".metrics-container .ant-layout {\n  background-color: #ffffff; }\n\n.metrics-container .ant-layout-sider {\n  background-color: white; }\n  .metrics-container .ant-layout-sider .ant-layout-sider-children {\n    height: 100% !important; }\n\n.metrics-container .ant-layout-header {\n  background-color: white; }\n\n.metrics-container .ant-layout-content {\n  background-color: white; }\n\n.metrics-container .ant-layout-footer {\n  background-color: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Analytics/components/MetricsContainer/style.scss
// module id = 982
// module chunks = 0